import type { MessageInstance } from 'antd/es/message/interface';
import { chatApis } from '@/configs/apis/chat';
import type { ChatGroupMember } from '@/contexts/chat/scripts/hooks/useChatGroup/types';
import { ShareQrCodeModal } from '.';

interface Props {
  messageApi: MessageInstance;
  apiParam: {
    user_id?: string;
    group_id?: string;
  };
}

const isDev = process.env.NODE_ENV === 'development';

export const useShareQrCodeModal = ({ apiParam, messageApi }: Props) => {
  const [open, setOpen] = useState(false);
  const [shareLink, setShareLink] = useState<string>('');

  const groupShareLink = useCallback(async () => {
    const res = await chatApis.getGroupShareLink(apiParam);
    if (isDev) {
      const url_ = new URL(res.url ?? '');
      setShareLink(`http://localhost:6789${url_.pathname}`);
    } else {
      setShareLink(res.url ?? '');
    }
  }, [apiParam]);

  const copyShareLink = useCallback(() => {
    navigator.clipboard.writeText(shareLink);
    messageApi.success('Copied');
  }, [messageApi, shareLink]);

  const shareQrCodeModal = useCallback(
    ({
      headerAvatar,
      headerName,
      shortName,
      members = [],
    }: {
      headerAvatar: string;
      headerName: string;
      shortName: string;
      members?: ChatGroupMember[];
    }) => {
      return (
        <ShareQrCodeModal
          headerAvatar={headerAvatar}
          headerName={headerName}
          shortName={shortName}
          members={members}
          modalProps={{
            open,
            onCancel: () => setOpen(false),
            title: 'QR Code',
          }}
          qrCodeProps={{
            value: shareLink,
            icon: '/favicon.png',
            errorLevel: 'H',
            size: 260,
            color: '#7750E5',
            bordered: false,
          }}
        />
      );
    },
    [open, shareLink]
  );

  return {
    open,
    setOpen,
    shareLink,
    copyShareLink,
    groupShareLink,
    shareQrCodeModal,
  };
};
